<template>
  <div class="content">
    <ValidationObserver ref="form">
      <form @submit.prevent="onDecision">
        <div class="holder container">
          <div class="content-body col-md-7 col-10">
            <div class="back-note">
              <p class="u-pc" v-html="$t('front_end.a055.back_note_ipad')"></p>
              <p class="u-sp" v-html="$t('front_end.a055.back_note_sp')"></p>
            </div>
            <div class="form-group">
              <label>
                {{ $t("front_end.a055.zip_code") }}
                <span class="text-danger">*</span>
              </label>
              <ValidationProvider
                mode="passive"
                vid="postalCode"
                :name="$t('front_end.a055.zip_code')"
                rules="required|length:7|numeric|half_size"
                v-slot="{ errors, classes, failedRules }"
                ref="postalCode"
              >
                <div class="row m-0 align-items-sm-center">
                  <input
                    type="text"
                    class="form-control col-4 input-zip-code"
                    ref="zip_code"
                    id="zip-code"
                    :class="classes"
                    maxlength="7"
                    v-model.trim="data.postNo"
                    :pattern="dynamicPattern"
                  />
                  <div class="col-6 col-md-3 row button-auto-input p-0">
                    <button
                      class="btn-custom offset-1"
                      type="button"
                      @click="searchAddress()"
                    >{{ $t("front_end.a055.auto_input") }}</button>
                  </div>
                </div>

                <div
                  class="error-msg"
                  v-if="errors && errors.length"
                >{{ failedRules.length ? $t('front_end.a055.errors.invalid_postal_code') :errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>
                {{ $t("front_end.a055.address") }}
                <span class="text-danger">*</span>
              </label>
              <ValidationProvider
                mode="passive"
                vid="prefecture"
                :name="$t('front_end.a055.address')"
                rules="required"
                v-slot="{ errors, classes, failedRules }"
              >
                <div class="select-box">
                  <select
                    class="form-control"
                    v-model="data.prefecture"
                    :class="classes"
                    ref="prefecture"
                    id="prefectureSelect"
                  >
                    <option v-for="(pref, index) in prefectureList" :key="index">{{ pref }}</option>
                  </select>
                </div>
                <div
                  class="error-msg"
                  v-if="failedRules.required"
                >{{ $t('front_end.a055.address') }}{{ $t('front_end.a055.validate.required') }}</div>
                <div class="error-msg" v-else-if="errors[0]">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>
                {{ $t("front_end.a055.address_district")
                }}
                <span
                  class="text-danger"
                >*</span>
              </label>
              <ValidationProvider
                mode="passive"
                vid="city"
                :name="$t('front_end.a055.address_district')"
                rules="required|full_size|max:100"
                v-slot="{ errors, classes, failedRules }"
              >
                <input
                  type="text"
                  class="form-control"
                  :class="classes"
                  v-model.trim="data.city"
                  ref="city"
                />
                <div
                  class="error-msg"
                  v-if="failedRules.full_size"
                >{{$t('front_end.a055.validate.address_district_full_size')}}</div>
                <div class="error-msg" v-else>{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>
                {{ $t("front_end.a055.street")
                }}
                <span class="text-danger">*</span>
              </label>
              <ValidationProvider
                mode="passive"
                vid="street"
                :name="$t('front_end.a055.street')"
                rules="required|max:255"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  :class="classes"
                  v-model.trim="data.street"
                  ref="street"
                />
                <div class="error-msg">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>{{ $t("front_end.a055.building") }}</label>
              <ValidationProvider
                mode="passive"
                vid="building"
                :name="$t('front_end.a055.building')"
                rules="max:255"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.building"
                  :class="classes"
                  ref="building"
                />
                <div class="error-msg">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>{{ $t("front_end.a055.city_name") }}</label>
              <ValidationProvider
                mode="passive"
                vid="company"
                :name="$t('front_end.a055.city_name')"
                rules="max:255"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  :class="classes"
                  v-model.trim="data.company"
                  ref="company"
                />
                <div class="error-msg">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>{{ $t("front_end.a055.deploy_name") }}</label>
              <ValidationProvider
                mode="passive"
                vid="department"
                :name="$t('front_end.a055.deploy_name')"
                rules="max:255"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  :class="classes"
                  v-model.trim="data.department"
                  ref="department"
                />
                <div class="error-msg">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>{{ $t("front_end.a055.position") }}</label>
              <ValidationProvider
                mode="passive"
                vid="position"
                :name="$t('front_end.a055.position')"
                rules="max:255"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  :class="classes"
                  v-model.trim="data.post"
                  ref="post"
                />
                <div class="error-msg">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>
                {{ $t("front_end.a055.name") }}
                <span class="text-danger">*</span>
              </label>
              <div class="input-name-body vee-validate">
                <div class="input-name">
                  <ValidationProvider
                    mode="passive"
                    ref="firstName"
                    vid="firstName"
                    :name="$t('front_end.a055.name')"
                    rules="required|full_size|max:255"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a055.first_name')"
                      v-model.trim="data.firstName"
                      ref="first_name"
                    />
                  </ValidationProvider>
                </div>
                <div class="input-name">
                  <ValidationProvider
                    mode="passive"
                    ref="lastName"
                    vid="lastName"
                    :name="$t('front_end.a055.name')"
                    rules="required|full_size|max:255"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a055.last_name')"
                      v-model.trim="data.lastName"
                      ref="last_name"
                    />
                  </ValidationProvider>
                </div>
                <div class="input-name">
                  <ValidationProvider
                    mode="passive"
                    ref="honorific"
                    vid="honorific"
                    :name="$t('front_end.a055.name')"
                    rules="required|full_size|max:255"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a055.honorific_title')"
                      v-model.trim="data.honorific"
                      ref="honorific_name"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div
                class="error-msg"
                v-if="errors.name && errors.name.length > 0"
              >
                {{ errors.name[0][0] }}
              </div>
            </div>
            <div v-html="rawHtmlInputField" class="form-group mb-0"></div>
            <!--  -->
            <template v-for="(row, index) in jointName">
              <div class="form-group" id="group${number}" :key="index">
                <label>
                  {{ $t("front_end.a055.next_name") }}{{ index + 1 }}
                </label>
                <div class="content-input-add">
                  <div class="input-name">
                    <ValidationProvider
                      mode="passive"
                      :vid="'last_name' + index"
                      ref="join_last_name"
                      :name="$t('front_end.a055.next_name') + (index + 1)"
                      :rules="'full_size|max:255|required_if:honorific_title' + index" 
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('front_end.a055.last_name')"
                        v-model.trim="row.lastName"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input-name">
                    <ValidationProvider
                      mode="passive"
                      :vid="'honorific_title' + index"
                      ref="honorific_title"
                      :name="$t('front_end.a055.next_name') + (index + 1)"
                      :rules="'full_size|max:255|required_if:last_name' + index"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('front_end.a055.honorific_title')"
                        v-model.trim="row.honorific"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input-name body-item-delete" @click="removeRow(index)">
                    <i
                      class="fa item-delete"
                      id="${textLabel}${number}"
                      data-menu="${number}"
                    >&#xf056;</i>
                    <font-awesome-icon icon="minus-circle" id="icon-minus" class="icon-add"></font-awesome-icon>
                  </div>
                </div>
                <div
                  class="error-msg"
                  v-if="
                    errors.jointName &&
                      errors.jointName.length > 0 &&
                      errors.jointName[index] &&
                      errors.jointName[index].length > 0
                  "
                >
                  {{ errors.jointName[index][0][0] }}
                </div>
              </div>
            </template>
            <!--  -->
          </div>
          <div class="plus-sub-name justify-content-center d-flex mt-5" @click="addRow">
            <font-awesome-icon
              icon="plus-circle"
              id="icon-plus"
              :class="['icon-add', { 'disable-btn-add': numberSub === 20 }]"
            ></font-awesome-icon>
            <label
              :class="[
                { 'disable-btn-add': numberSub === 20 },
                'text-add-plus'
              ]"
            >{{ $t("front_end.a055.text_add_plus") }}</label>
          </div>
        </div>
        <div class="footer-btn mb-5">
          <button
            type="submit"
            class="btn-confirm-input btn-custom col-md-4 col-8"
          >{{ $t("front_end.a055.confirm") }}</button>
        </div>
      </form>
    </ValidationObserver>
    <fe-alert ref="confirmDecision" :datas="confirmDecision">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a055.message_confirm')" />
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-right"
          @click="onResetFormData()"
        >{{ $t("front_end.a050.csv.yes") }}</button>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-left"
          @click="cancelResetFormData()"
        >{{ $t("front_end.a050.csv.cancel") }}</button>
      </template>
    </fe-alert>
  </div>
</template>
<script>
import apiService from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import FeAlert from "@/components/fe/common/FeAlert";
import deviceUtil from "@/utils/deviceUtil";

export default {
  name: "A055",
  components: {
    FeAlert
  },
  data() {
    return {
      data: {
        seqNo: "",
        postNo: "",
        prefecture: "",
        city: "",
        street: "",
        building: "",
        company: "",
        department: "",
        post: "",
        firstName: "",
        lastName: "",
        honorific: "",
        jointName: ""
      },
      jointName: [
        {
          lastName: "",
          honorific: ""
        }
      ],
      prefectureList: [],
      confirmDecision: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: "static"
        }
      },
      nextRegisterAddress: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: "static"
        }
      },
      rawHtmlInputField: "",
      numberSub: 0,
      subReceiverListTemp: [],
      confirmModal: false,
      insertComplete: false,
      buttonConfirm: this.$t("front_end.a055.yes"),
      buttonCancel: this.$t("front_end.a055.cancel"),
      messageConfirm: this.$t("front_end.a055.message_confirm"),
      nameErrorFormatNumber: 0,
      nameErrorEmptyNumber: 0,
      errors: {
        name: [],
        jointName: [],
      }
    };
  },
  created() {
    this.prefectureList = this.$configFe.prefectures;
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === "input") {
        e.preventDefault();
      }
    });
  },
  methods: {
    // todo
    async getPrefectureList() {
      let url = apiEndpoints.getPrefectures;
      try {
        let prefecture = await apiService.post(url, {});
        if (prefecture && prefecture.status == 200) {
          this.prefectureList = prefecture.data.prefectures;
        }
      } catch (e) {
        // console.log(e);
      }
    },
    addRow() {
      this.jointName.push({
        lastName: "",
        honorific: ""
      });
      if (this.errors.jointName && this.errors.jointName.length > 0) {
        this.errors.jointName.push([]);
      }
    },
    removeRow(index) {
      this.jointName.splice(index, 1);
      if (this.errors.jointName && this.errors.jointName.length > 0) {
        this.errors.jointName.splice(index, 1);
      }
    },
    async onDecision() {
      let formValidate = await this.validateForm();
      if (!formValidate) {
        return;
      };
      // console.log("onClickAction formValidate", formValidate);
      this.$refs.confirmDecision.hide();
      let dataOld = localStorage.getItem("personal_address")
        ? JSON.parse(localStorage.getItem("personal_address"))
        : [];
      let data = this.data;
      let jointNameArray = [];
      let jointName = "";
      this.jointName.forEach(element => {
        jointName = jointName
          ? jointName + "," + element.lastName + element.honorific
          : element.lastName + element.honorific;

        jointNameArray.push({lastName:element.lastName , honorific:element.honorific});
      });
      data.jointNameArray = jointNameArray;
      data.jointName = jointName;
      data.checkDefault = true;
      if (dataOld) {
        dataOld.push(this.data);
      } else {
        dataOld = this.data;
      }
      localStorage.setItem("personal_address", JSON.stringify(dataOld));
      this.$refs.confirmDecision.show();
    },
    async validateForm() {
      let formValid = await this.$refs.form.validate();
      this.validateCustom();
      return formValid;
    },
    onResetFormData() {
      this.data = {
        seqNo: "",
        postNo: "",
        prefecture: "",
        city: "",
        street: "",
        building: "",
        company: "",
        department: "",
        post: "",
        firstName: "",
        lastName: "",
        honorific: "",
        jointName: ""
      };
      this.jointName = [
        {
          lastName: "",
          honorific: ""
        }
      ];
      this.$refs.confirmDecision.hide();
    },
    cancelResetFormData() {
      this.$refs.confirmDecision.hide();
      this.$store.commit("addressRegistration/SAVE_ADDRESS", this.data);
      this.$router.push({ name: "a050" });
    },
    async searchAddress() {
      let isValid = this.$refs.postalCode.validate();
      if (!isValid) {
        return;
      }
      if (this.data.postNo.length !== 7) {
        return;
      }
      let url = apiEndpoints.searchAddress;
      try {
        let result = await apiService.post(url, {
          postalCode: this.data.postNo
        });
        if (result && result.status == 200) {
          let dataAddress = result.data.address;
          this.data.prefecture = dataAddress.prefectures;
          this.data.city = dataAddress.city;
          this.data.street = dataAddress.townArea;
        }
      } catch (e) {
        // console.log(e);
      }
    },
    async validateCustom() {
      let errorName = [];
      if (
        this.$refs.firstName?.errors &&
        this.$refs.firstName.errors.length > 0
      ) {
        errorName.push(this.$refs.firstName.errors);
      }
      if (
        this.$refs.lastName?.errors &&
        this.$refs.lastName.errors.length > 0
      ) {
        errorName.push(this.$refs.lastName.errors);
      }
      if (
        this.$refs.honorific?.errors &&
        this.$refs.honorific.errors.length > 0
      ) {
        errorName.push(this.$refs.honorific.errors);
      }
      let jointName = [];
      this.jointName.forEach((e, key) => {
        let jointKey = [];
        if (
          this.$refs.join_last_name[key].errors &&
          this.$refs.join_last_name[key].errors.length > 0
        ) {
          if (this.$refs.join_last_name[key].failedRules.required_if) {
            let messLastName =
              this.$t("front_end.a055.last_name") +
              this.$t("front_end.a055.validate.required_jointname");
            jointKey.push([messLastName]);
          } else {
            jointKey.push(this.$refs.join_last_name[key].errors);
          }
        }
        if (
          this.$refs.honorific_title[key].errors &&
          this.$refs.honorific_title[key].errors.length > 0
        ) {
          if (this.$refs.honorific_title[key].failedRules.required_if) {
            let messjointKey =
              this.$t("front_end.a055.honorific_title") +
              this.$t("front_end.a055.validate.required_jointname");
            jointKey.push([messjointKey]);
          } else {
            jointKey.push(this.$refs.honorific_title[key].errors);
          }
        }
        jointName.push(jointKey);
      })
      this.errors.name = errorName;
      this.errors.jointName = jointName;
    }
  },
  computed: {
    dynamicPattern() {
      return deviceUtil.isiOS() ? "\\d*" : ".*";
    }
  }
};
</script>
<style scoped src="../../assets/css/toAddressInput/toAddressInput.css"></style>
<style scoped src="../../assets/css/common/dialogCommon.css"></style>

<style lang="css" scoped>
.border-input {
  padding: 0.3rem;
  border: 2px solid #717171;
}

.body-item-delete {
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-name {
  width: 30% !important;
}

.content-input-add {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.border-input:focus {
  border: 2px solid #717171;
}

.input-name-add {
  width: 30% !important;
}

.item-delete {
  color: #dd0017;
  font-size: 2rem;
  cursor: pointer;
  display: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.width-error-name {
  width: 30%;
}

.theme-mourning .item-delete {
  color: #181475 !important;
}

.maxw-350 {
  max-width: 350px !important;
}
</style>
<style lang="css" scoped>
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.6;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  border: 2px solid #717171;
}
.error-msg {
  font-size: 12px;
  color: #dd0017;
  width: 100%;
  margin-top: 0;
}
.form-group label {
  font-weight: 400;
  line-height: 1.6;
}

.input-name-body.vee-validate span {
  display: contents;
}
.btn-custom {
  min-width: unset;
  margin-top: unset;
  padding: 0.5rem !important;
  margin-bottom: unset;
}
select#prefectureSelect {
  position: relative;
  display: block;
  padding: 0 45px 0 10px;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 172 172' fill='none' %3e%3cg fill='none' fill-rule='nonzero' stroke='none' stroke-width='10' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='10' style='mix-blend-mode: normal'%3e%3cpath d='M0,172v-172h172v172z' fill='none'%3e%3c/path%3e%3cpath d='M0,172v-172h172v172z' fill='none'%3e%3c/path%3e%3cpath d='M3.44,168.56v-165.12h165.12v165.12z' fill='none'%3e%3c/path%3e%3cpath d='M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86v0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z' fill='none'%3e%3c/path%3e%3cpath d='M86,168.56c-45.59663,0 -82.56,-36.96337 -82.56,-82.56v0c0,-45.59663 36.96337,-82.56 82.56,-82.56v0c45.59663,0 82.56,36.96337 82.56,82.56v0c0,45.59663 -36.96337,82.56 -82.56,82.56z' fill='none'%3e%3c/path%3e%3cpath d='M0,172v-172h172v172z' fill='none'%3e%3c/path%3e%3cpath d='M3.44,168.56v-165.12h165.12v165.12z' fill='none'%3e%3c/path%3e%3cg fill='%23dd0017'%3e%3cpath d='M86,100.84217l-27.38383,-27.38383c-2.967,-2.967 -7.783,-2.967 -10.75,0v0c-2.967,2.967 -2.967,7.783 0,10.75l33.067,33.067c2.80217,2.80217 7.33867,2.80217 10.13367,0l33.067,-33.067c2.967,-2.967 2.967,-7.783 0,-10.75v0c-2.967,-2.967 -7.783,-2.967 -10.75,0z'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e") no-repeat right center/45px 45px;
}
@media screen and (min-width: 1024px) {
  .btn-custom {
    padding: 10px;
  }
}
@media screen and (max-width: 768px) {
  .btn-custom {
    padding: 10px;
  }
  .form-control {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .btn-custom {
    padding: 5px;
  }
  .input-zip-code {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
}
.u-sp {
  display: block;
}

.u-pc {
  display: none;
}

@media screen and (min-width: 768px) {
  .u-sp {
    display: none;
  }

  .u-pc {
    display: block;
  }
}
</style>
